import { AddResidentBioForm } from "app/services/api/types/residents/models/AddResidentBioForm";
import { ResidentInputFields } from "app/services/api/types/residents/models/ResidentInputFields";
import { Control } from "react-hook-form";
import { View } from "react-native";
import { FormControlledDatePicker } from "ui/molecules/form/FormControlledDatePicker";
import { FormControlledDropdown } from "ui/molecules/form/FormControlledDropdown";
import { FormControlledInput } from "ui/molecules/form/FormControlledInput";
import { requiredValidation } from "ui/utils/Validators";
import { PropsWithChildren } from "react";
import FormControlledLocationSelector from "app/components/molecules/FormControlledLocationSelector";
interface Props {
  fields: ResidentInputFields[];
  control: Control<AddResidentBioForm>;
}
export function ResidentInfoInputGroup({
  fields,
  control,
  children,
}: PropsWithChildren<Props>) {
  return (
    <View className="md:w-11/12 grid md:grid-cols-3 gap-8">
      {fields.map(
        ({
          id,
          name,
          label,
          placeholder,
          isRequired,
          inputType,
          options,
          rules,
          disabled,
        }) => (
          <View key={id}>
            {inputType === "date" ? (
              <FormControlledDatePicker<AddResidentBioForm>
                id={id}
                name={name}
                control={control}
                label={label}
                placeholder={placeholder}
                isRequired={isRequired}
                rules={rules}
                isDisabled={disabled}
              />
            ) : inputType === "dropdown" && options?.length ? (
              <FormControlledDropdown
                name={name}
                control={control}
                label={label}
                placeholder={placeholder}
                isRequired={isRequired}
                options={options}
                rules={{
                  required: isRequired ? requiredValidation(label) : undefined,
                }}
                isDisabled={disabled}
              />
            ) : inputType === "location" ? (
              <FormControlledLocationSelector
                control={control}
                name={name}
                label={label}
              />
            ) : (
              <FormControlledInput<AddResidentBioForm>
                id={id}
                name={name}
                control={control}
                label={label}
                placeholder={placeholder}
                isRequired={isRequired}
                rules={rules}
                isDisabled={disabled}
              />
            )}
          </View>
        ),
      )}
      {children}
    </View>
  );
}
